import { getNotes } from "../../helpers/Notes";
import { ICanvasRenderOptions, IDraw2D } from "../abstraction/IDraw2D";
import { IViewLayer } from "../abstraction/IViewLayer";


export class NotesDraw implements IDraw2D {

    protected _layer: IViewLayer;

    constructor() {

    }

    attach(layer: IViewLayer) {
        this._layer = layer;
    }

    draw2D(ctx: CanvasRenderingContext2D, options: ICanvasRenderOptions) {

        const notes = getNotes();

        ctx.save();
        ctx.resetTransform();

        ctx.clearRect(0, 0, this._layer.host.margin.x, options.viewSize.height);

        ctx.fillStyle = "#999";
        ctx.font = (13 * window.devicePixelRatio) + "px Arial";

        ctx.beginPath();

        notes.forEach((n, i) => {

            const log = Math.log2(n.freq);

            const pt = options.viewTransform.transformPoint({ x: 0, y: log });

            const txt = n.scale + " " + n.name.toUpperCase();

            const textSize = ctx.measureText(txt);

            this._layer.host.margin.x = Math.max(this._layer.host.margin.x, textSize.width + 10);

            if (pt.y - textSize.actualBoundingBoxAscent / 2 < 10)
                return;

            ctx.moveTo(this._layer.host.margin.x, pt.y);
            ctx.lineTo(options.viewSize.width, pt.y);

      
            ctx.fillText(txt, 0, pt.y + textSize.actualBoundingBoxAscent / 2)
        });

        ctx.lineWidth = 1;
        ctx.strokeStyle = "#777";
        ctx.stroke();

        ctx.restore();
    }
}